import React, { useState } from 'react';
import './CareDeliverySection.css';

function CareDeliverySection({
  tagline = 'HOW CARE IS DELIVERED',
  headingLine1 = 'We’re revolutionizing',
  headingItalic = 'how',
  headingLine2 = 'care is delivered.',
  consultationLink = '/book-a-consultation/membership',
  tabsData = [
    {
      id: '01',
      title: '24/7 fast access to care',
      summary: 'Medical support when and where you need it. No waitlist. No delay.',
      description: 'Same-day clinical questions, prescription renewals, and a person who already knows your chart. Travel does not pause the relationship. If a hospital is required, we help you navigate it — we do not leave a voicemail and hope.'
    },
    {
      id: '02',
      title: 'Personalized case management',
      summary: 'One team holds continuity, coordination, and clarity at every touchpoint.',
      description: 'Physicians, naturopaths, physiologists, and health strategists share one roof and one plan. Results are synthesized, not scattered across portals. You always know the next step, and who owns it.'
    },
    {
      id: '03',
      title: 'Longevity, not just treatment',
      summary: 'We plan, prevent, and optimize long before symptoms arrive.',
      description: 'Annual baselines, eight risk domains, and monthly coaching so small drifts are caught while they are still small. The work is quiet on purpose. The point is a life that does not revolve around clinics.'
    }
  ]
}) {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const activeTab = tabsData[activeTabIndex];

  return (
    <section className="ttc-care-delivery-section py-5">
      <div className="container py-lg-4">
        <div className="row g-0 ttc-care-delivery-card overflow-hidden">
          
          {/* Left Column: Dynamic Detailed Content */}
          <div className="col-12 col-lg-7 p-4 p-md-5 d-flex flex-column justify-content-between ttc-care-left-col">
            <div>
              {/* Tagline */}
              <div className="ttc-care-tagline text-uppercase mb-3 d-flex align-items-center gap-2">
                <span className="ttc-care-bullet">•</span>
                <span>{tagline}</span>
              </div>

              {/* Main Heading */}
              <h2 className="ttc-care-heading text-white mb-5">
                {headingLine1} <span className="ttc-care-italic">{headingItalic}</span> <br />
                {headingLine2}
              </h2>

              {/* Active Tab Subheading & Body Text */}
              <div className="ttc-care-active-content mb-4">
                <h3 className="ttc-care-tab-detail-title text-white mb-3">
                  {activeTab.title}
                </h3>
                <p className="ttc-care-tab-detail-desc mb-0">
                  {activeTab.description}
                </p>
              </div>
            </div>

            {/* Updated CTA Link */}
            <div className="pt-3">
              <a 
                href={consultationLink} 
                className="ttc-care-cta-link d-inline-flex align-items-center gap-2 text-decoration-none"
              >
                <span>Book consultation</span>
                <span className="ttc-care-cta-arrow">→</span>
              </a>
            </div>
          </div>

          {/* Right Column: Tab Selector List */}
          <div className="col-12 col-lg-5 ttc-care-right-col d-flex flex-column">
            {tabsData.map((tab, idx) => {
              const isActive = idx === activeTabIndex;
              return (
                <div
                  key={tab.id}
                  onClick={() => setActiveTabIndex(idx)}
                  className={`ttc-care-tab-item p-4 border-bottom ${isActive ? 'active' : ''}`}
                  role="button"
                  tabIndex={0}
                >
                  <div className="d-flex align-items-baseline gap-3 mb-2">
                    <span className="ttc-care-tab-id">{tab.id}</span>
                    <h4 className="ttc-care-tab-title mb-0">{tab.title}</h4>
                  </div>
                  <p className="ttc-care-tab-summary mb-0 ms-4 ps-2">
                    {tab.summary}
                  </p>
                </div>
              );
            })}
          </div>

        </div>
      </div>
    </section>
  );
}

export default CareDeliverySection;